<template>
  <div>
    <v-data-table
      calculate-widths
      class="elevation-0 new-tender-members-table members-table main__light_green"
      disable-pagination
      :expanded.sync="expanded_sync"
      fixed-header
      :headers="headers"
      hide-default-footer
      :hide-default-header="hide_header"
      :item-key="item_key || 'organizationUsreou'"
      :items="sliced_items"
      :loading-text="$t('Tenders.Loading')"
      :no-data-text="$t('Tenders.NoData')"
      :no-results-text="$t('Tenders.NoData')"
      :show-select="!hide_select"
      single-expand
      @click:row="expandRow">
      <template #header>
        <slot name="header_item"/>
      </template>
      <template #[`header.data-table-select`]>
        <slot name="header_table_select"/>
      </template>

      <template #[`item.data-table-select`]="{ item, count: countSelect }">
        <slot
          :count="countSelect"
          :item="item"
          name="item_table_select"/>
      </template>

      <template #[`item.participationCount`]="{ item }">
        <span class="h7-text">{{ item.participationCount || '–' }}</span>
      </template>
      <template #[`item.participationsCount`]="{ item }">
        <span class="h7-text">{{ item.participationsCount || '–' }}</span>
      </template>

      <template #[`item.organizationTitle`]="{ item }">
        <span class="h7-text">{{ item.organizationTitle || item.title || '–' }}</span>
      </template>

      <template #[`item.organizationUsreou`]="{ item }">
        <span class="h7-text">{{ item.organizationUsreou || item.usreou || '–' }}</span>
      </template>

      <template #[`item.supplierRatings`]="{ item }">
        <span class="h7-text">{{ item.supplierRatings || item.rating || '–' }}</span>
      </template>

      <template #[`item.userConcatNameEmail`]="{ item: user }">
        <div
          class="flex">
          <UserIcon
            class="pa-0 mr-2"
            :name="user.userName || user.name || user.email || '-'"
            size="38"
            :src="user.avatar"/>
          <div class="flex wrap pl-1">
            <div
              class="h7-text width-100 my-auto">
              {{ user.userName || user.name || '-' }}
            </div>
            <div
              v-if="user.email"
              class="h7-text secondary__green_not_active--text width-100">
              {{ user.email }}
            </div>
          </div>
        </div>
      </template>

      <template #[`expanded-item`]="{ headers: headersExpand, item: itemExpand }">
        <slot
          :group="itemExpand"
          :headers="headersExpand"
          name="expanded_item"/>
      </template>

      <template #[`body.append`]>
        <tr v-if="items.length > count && infinity_updater">
          <td :colspan="headers.length">
            <InfinityUpdater
              :action="infinityLoad"
              :active="items.length > count"
              call-on-mount
              :selector="inf_selector || ' .members-table .v-data-table__wrapper'"/>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'

export default {
  name: 'organisationsTable',
  data() {
    return {
      count: 0,
    }
  },
  props: {
    items: Array,
    headers: Array,
    expanded: Array,
    hide_select: Boolean,
    item_key: String,
    inf_selector: String,
    infinity_updater: Boolean,
    hide_header: Boolean
  },
  computed: {
    sliced_items() {
      return this.infinity_updater ? this.items.slice(0,  this.count) : this.items

    },
    per_page() {
      return Math.round(document.documentElement.clientHeight / 45 )
    },
    expanded_sync: {
      get() {
        return this.expanded
      },
      set(value) {
        this.$emit('update:expanded', value)
      }
    },
  },
  methods: {
    expandRow (item) {
      this.$emit('expandRow', item)
    },
    infinityLoad() {
      if (this.count < this.items.length) {
        this.count = Math.min(this.items.length, this.count + this.per_page)
      }
    },
  },
  watch: {
    items(val, old) {
      if ( old.length && val.length && old.length != val.length) {
        this.count = 0
        this.infinityLoad()
      }
    }
  },
  components: {
    UserIcon,
    InfinityUpdater
  }
}
</script>
